/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'

import { styled } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'

// Styling the expand more IconButton for the GiftsCard and GiftIdeasCard
export const ExpandMore = styled((props) => {
  const { expand, ...other } = props
  return <IconButton {...other} />
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  // marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  // color: 'blue',
  // border: 'solid 1px black', 
  backgroundColor: 'lightyellow',
  boxShadow: !expand ? '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)' : '0px -3px 1px -2px rgba(0,0,0,0.2), 0px -2px 2px 0px rgba(0,0,0,0.14), 0px -1px 5px 0px rgba(0,0,0,0.12)',
}))